module.exports = __webpack_public_path__ + "img/6.da7af4f8.png";